import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CandidateCard = ({ candidate, onRevealRequest, onViewDetails }) => {
  const getMatchColor = (score) => {
    if (score >= 80) return 'text-[#10B981]';
    if (score >= 60) return 'text-[#F59E0B]';
    return 'text-[#6B7280]';
  };

  const getMatchBgColor = (score) => {
    if (score >= 80) return 'bg-[#10B981]/10';
    if (score >= 60) return 'bg-[#F59E0B]/10';
    return 'bg-[#E5E7EB]';
  };

  return (
    <div className="bg-white rounded-2xl p-4 md:p-6 border border-[#E5E7EB] hover:shadow-lg transition-all duration-250">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="text-base md:text-lg font-semibold text-[#111827]">
              {candidate?.title}
            </span>
            {candidate?.isNew && (
              <span className="px-2 py-1 bg-[#5B2DFF]/10 text-[#5B2DFF] text-xs font-medium rounded-full">
                New
              </span>
            )}
          </div>
          <p className="text-sm md:text-base text-[#6B7280] line-clamp-2">
            {candidate?.summary}
          </p>
        </div>
        <div className={`ml-4 flex flex-col items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-xl ${getMatchBgColor(candidate?.matchScore)}`}>
          <span className={`text-xl md:text-2xl font-bold ${getMatchColor(candidate?.matchScore)}`}>
            {candidate?.matchScore}%
          </span>
          <span className="text-xs text-[#6B7280]">{candidate?.matchAnalysis?.recommendation || 'Match'}</span>
        </div>
      </div>
      {candidate?.matchAnalysis && !candidate?.matchAnalysis?.error && (
        <div className="mb-4 p-3 bg-[#F6F7FB] rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Target" size={14} color="#5B2DFF" />
            <span className="text-xs font-semibold text-[#111827]">AI Analysis</span>
          </div>
          <p className="text-xs text-[#6B7280] mb-2">{candidate?.matchAnalysis?.matchSummary}</p>
          {candidate?.matchAnalysis?.keyStrengths?.length > 0 && (
            <div className="space-y-1">
              {candidate?.matchAnalysis?.keyStrengths?.slice(0, 2)?.map((strength, index) => (
                <div key={index} className="flex items-start gap-1.5">
                  <Icon name="CheckCircle2" size={12} color="#10B981" className="mt-0.5 flex-shrink-0" />
                  <span className="text-xs text-[#111827]">{strength}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      <div className="grid grid-cols-2 gap-3 md:gap-4 mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Briefcase" size={16} color="#6B7280" />
          <span className="text-sm text-[#6B7280]">{candidate?.experience}</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="MapPin" size={16} color="#6B7280" />
          <span className="text-sm text-[#6B7280]">{candidate?.location}</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Building2" size={16} color="#6B7280" />
          <span className="text-sm text-[#6B7280]">{candidate?.industry}</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="TrendingUp" size={16} color="#6B7280" />
          <span className="text-sm text-[#6B7280]">{candidate?.seniority}</span>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mb-4">
        {candidate?.skills?.slice(0, 4)?.map((skill, index) => (
          <span
            key={index}
            className="px-3 py-1 bg-[#F6F7FB] text-[#111827] text-xs md:text-sm rounded-full"
          >
            {skill}
          </span>
        ))}
        {candidate?.skills?.length > 4 && (
          <span className="px-3 py-1 bg-[#F6F7FB] text-[#6B7280] text-xs md:text-sm rounded-full">
            +{candidate?.skills?.length - 4} more
          </span>
        )}
      </div>
      <div className="flex items-center justify-between pt-4 border-t border-[#E5E7EB]">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-[#10B981]"></div>
          <span className="text-sm text-[#6B7280]">
            Profile Strength: <span className="font-medium text-[#111827]">{candidate?.profileStrength}%</span>
          </span>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="FileSearch"
            iconPosition="left"
            onClick={() => onViewDetails(candidate)}
          >
            View
          </Button>
          <Button
            variant="default"
            size="sm"
            iconName="Unlock"
            iconPosition="left"
            onClick={() => onRevealRequest(candidate)}
          >
            Request Reveal
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CandidateCard;